var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16.0002H19C20.6569 16.0002 22 14.6571 22 13.0002V3.73725C22 2.13986 20.2197 1.18708 18.8906 2.07315L16 4.00022H9C7.34315 4.00022 6 5.34336 6 7.00022V8.00021H5C3.34315 8.00021 2 9.34336 2 11.0002V19.839C2 21.516 3.93986 22.4483 5.24939 21.4007L7 20.0002H15C16.6569 20.0002 18 18.6571 18 17.0002V16.0002ZM16.5547 4.83227C16.3904 4.94178 16.1974 5.00022 16 5.00022H9C7.89543 5.00022 7 5.89565 7 7.00022V8.00021H15C16.6569 8.00021 18 9.34336 18 11.0002V15.0002H19C20.1046 15.0002 21 14.1048 21 13.0002V3.73725C21 2.93855 20.1099 2.46216 19.4453 2.9052L16.5547 4.83227ZM7 19.0002C6.77293 19.0002 6.55262 19.0775 6.37531 19.2193L4.6247 20.6198C3.96993 21.1436 3 20.6775 3 19.839V11.0002C3 9.89564 3.89543 9.00021 5 9.00021H15C16.1046 9.00021 17 9.89564 17 11.0002V17.0002C17 18.1048 16.1046 19.0002 15 19.0002H7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 14C6.5 13.7239 6.72386 13.5 7 13.5H13C13.2761 13.5 13.5 13.7239 13.5 14C13.5 14.2761 13.2761 14.5 13 14.5H7C6.72386 14.5 6.5 14.2761 6.5 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.d899b1549746a40703b61337a8370766.svg";
export { ForwardRef as ReactComponent };